module.exports = "/lucky-balls/img/drum/drum_loop_001.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/lucky-balls/img/drum/drum_loop_001.png
// module id = 1016
// module chunks = 0